<div class="flex-container">
  <div>
    <h2>Entenda a pirâmide alimentar</h2>
    <p class="paragraph">A pirâmide alimentar é uma forma bem simples de classificar os alimentos e introduzir uma forma de reeducação alimentar
      a vida das pessoas. Adaptamos a pirâmide conforme a oferta de produtos da cantina! Assim, você poderá acompanhar a alimentação de seu filho na escola.
    </p>
  </div>
</div>

<div class="flex-container">
  <div>
    <h2>Pirâmide Nutricional</h2>
    <img class="img-responsive" src="assets/images/food_pyramid-2.png">
    <!-- <p>Clique aqui e saiba mais sobre a pirâmide alimentar!</p> -->
  </div>
</div>

<div class="flex-container">
  <div class="paragraph">
    <h3>1 - Doces</h3>
    <p>Chocolate, sorvete, bolo, etc. Consuma esporadicamente, pois são ricos em calorias e pobre em nutrientes.
    </p>

    <h3>2 - Cereais e ovos</h3>
    <p>Omelete, espetinhos, sardinhas, atum. Ricos em proteínas e gorduras, fornecem muita energia e dão saciedade.
    </p>

    <h3>3 - Laticínios</h3>
    <p>Queijo, leite, iogurtes, etc. Ricos em proteínas e cálcio. Opte sempre por produtos magros.
    </p>

    <h3>4 - Sucos naturais</h3>
    <p>Sucos de frutas diversas. Evite refrigerantes e sucos industrializados, pois são ricos em açúcares, corantes e aditivos.
    </p>

    <h3>5 - Frutas</h3>
    <p>Abacaxi, maçã, banana, mamão, etc. Ricos em vitaminas e fibras. Sempre que possível, consumir com a casca.
    </p>

    <h3>6 - Carboidratos</h3>
    <p>Cereais, pães, torradas e bolos, etc. Prefira os integrais, pois são ricos em fibras, que também ajudam na regulação intestinal.   
    </p>

    <h3>7 - Frituras e industrializados</h3>
    <p>Coxinha, pastel, quibe, chips, etc. Evite, pois o alto teor de gorduras pode trazer problemas cardiovasculares no futuro.
    </p>

  </div>
</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/pyramid-desc/pyramid-desc.component.html